import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';
import { CreditCardStatus } from '../auth/models/credit-card-status';
import { UserInfo, Zone } from '../auth/models/user';

export function getCreditExpiresDate(user: UserInfo) {
  return DateTime.fromISO(user?.creditExpiredDate?.toString())
    .setZone(Zone[user?.region])
    .endOf('day');
}
export function checkCreditCardStatus(user: UserInfo): CreditCardStatus {
  let showExpireWarn = false;
  let isExpired = false;
  const creditExpiresDate = getCreditExpiresDate(user);

  isExpired =
    creditExpiresDate
      .diff(DateTime.utc().setZone(Zone[user?.region]).startOf('day'), 'days')
      .toObject().days < 0
      ? true
      : false;

  if (!isExpired) {
    const warnAt = creditExpiresDate.minus({
      days: environment.creditExpireWarningDays,
    });
    showExpireWarn =
      DateTime.now().toUTC().setZone(Zone[user?.region]) < warnAt
        ? false
        : true;
    return { isCCExpired: isExpired, hasCCExpireWarn: showExpireWarn };
  }
  return { isCCExpired: isExpired };
}
